// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2do7B","disabled":"FileBtn_disabled__1VK9q","warn":"FileBtn_warn__lV1em","fade":"FileBtn_fade__3l1kl"};